module.exports = __webpack_public_path__ + "static/sync-api-665eec1aae72f8bc803dc66573ed6b6e.png";